<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KANBAN_LOG_EMPTY_VALUE } from '@entities/kanban-comment'
import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useKanbanLogDeadline } from '../../model/log/use-kanban-log-deadline.hook'
import KanbanLogItemInfo from './KanbanLogItemInfo.vue'

defineOptions({
  name: 'KanbanLogDeadline',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  oldValue: string | null
  value: string | null
}>()

const {
  refOldDate,
  refNewDate,
} = useKanbanLogDeadline({
  oldValue: props.oldValue,
  value: props.value,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      label="change deadline"
    />
    <div class="kanban-log-field__row">
      <AppText
        v-if="refOldDate"
        name="body2"
        color="slate-900"
      >
        {{ refOldDate }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
      <IconContainer>
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <AppText
        v-if="refNewDate"
        name="body2"
        color="slate-900"
      >
        {{ refNewDate }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />